import { Box } from "@planningcenter/tapestry-react"
import { arrayOf, number, shape, string } from "prop-types"

const Reminders = ({ reminders }) => {
  return reminders.map(reminder => (
    <Box key={reminder.id}>
      A reminder will be sent to all attendees at {reminder.sendAtTime} on {reminder.sendAtDate} (
      {reminder.durationString} before the event).
    </Box>
  ))
}

Reminders.propTypes = {
  reminders: arrayOf(
    shape({
      id: number,
      sendAtTime: string,
      sendAtDate: string,
      durationString: string
    })
  )
}

export default Reminders
